import { getWithToken } from 'api/network';
import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  fetchAssumptionGroups,
  setGroups,
  setGroupsAreLoading,
} from '../../../store/actions';

export function* fetchAssumptionGroupsSaga() {
  yield takeEvery(fetchAssumptionGroups, function* ({ payload }) {
    try {
      yield put(setGroupsAreLoading(true));

      const url = `/api/assumptions/modules/${payload}/groups`;
      const res = yield getWithToken(url);
      const data = yield res.json();

      yield put(setGroups(data));
      yield put(setGroupsAreLoading(false));
    } catch (error) {
      yield put(
        appNotify(
          `Failure in fetchAssumptionGroupsSaga: ${error.message}`,
          'error'
        )
      );
      yield put(setGroupsAreLoading(false));
    }
  });
}
